jQuery(document).ready(function ($) {
  $(".wp-block-sivananda-blocks-tabbed-pdf-viewer").each(function () {
    const $tabbedPdfViewer = $(this);
    const $buttons = $tabbedPdfViewer.find('.tab-button');
    const $tabContent = $tabbedPdfViewer.find('.tab-content');

    $buttons.click(function () {
      const
        $button = $(this),
        pdfUrl = $button.data('pdf-url');

      $tabContent
        .empty()
        .append(`<embed src="${pdfUrl}" type="application/pdf" width="100%" height="600px" />`);

      $buttons.removeClass('active');
      $button.addClass('active');
    });
  });
});
